
<Card
    class="OverviewMetricCard"
    :class="[cardClass, { 'is-loading': loading, 'is-small': size === 'small' }]"
    :size="size === 'small' ? 'small' : 'medium'"
>
    <div v-if="loading" class="metric-content-skeleton">
        <div class="skeleton-icon"></div>
        <div class="skeleton-details">
            <div class="skeleton-title"></div>
            <div class="skeleton-value"></div>
        </div>
    </div>

    <div v-else class="metric-content">
        <div class="metric-icon" :class="iconClass">
            <i :class="icon"></i>
        </div>
        <div class="metric-details">
            <div class="title-value-row">
                <h3>{{ title }}</h3>
                <div class="metric-value">{{ value }}</div>
            </div>
            <div v-if="subText" class="metric-sub-text">
                {{ subText }}
            </div>
            <div v-if="change" class="metric-change" :class="changeClass">
                <span>{{ change }}</span>
                <i
                    class="trend-icon ri-arrow-up-line"
                    :class="{
                        'ri-arrow-down-line': changeType === 'negative',
                    }"
                ></i>
            </div>
        </div>
    </div>

    <div v-if="!loading && $slots.info" class="info-icon">
        <slot name="info"></slot>
    </div>

    <div v-if="!loading && $slots.actions" class="card-actions">
        <slot name="actions"></slot>
    </div>
    <div v-if="!loading && progress !== null" class="progress-container">
        <div class="progress-bar" :style="{ width: `${progress}%` }"></div>
        <div v-if="progressText" class="progress-text">
            {{ progressText }}
        </div>
    </div>
</Card>
